(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["Particle_temporary"] = factory(require("jQuery"));
	else
		root["Particle_temporary"] = factory(root["jQuery"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__2__) {
return 